import React, { useState } from 'react';
import './css/About.css'; // Dedicated page styles
import { useNavigate } from "react-router-dom";


// Reusing your standalone, modular layout components
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

// Import your custom images here
import aboutHeroBg from '../images/banner-about.png';
import aboutDetailsImg from '../images/AboutRight.png';

// Import your custom images here at the top
import featureSectionBg from '../images/Banner5.png'; // New Background Import
import featureSectionBg2 from '../images/Banner3.png'; // New Background Import

// Slide-Specific Image Imports
import featureLeftImg1 from '../images/forum-dash1.png';
import featureLeftImg2 from '../images/forum-dash1.png';
import featureLeftImg3 from '../images/forum-dash1.png';

import Why1 from '../images/why1.png';
import Why2 from '../images/why2.png';
import Why3 from '../images/why3.png';
import Why4 from '../images/why4.png';

import Team1 from '../images/founders-icon.png';
import Team2 from '../images/advisors-icon.png';
import Team3 from '../images/patrons-icon.png';
import Team4 from '../images/board-members-icon.png';

// React Icons (Using react-icons/fa or similar icon framework)

import DownloadApp from './components/DownloadApp';

function About() {
    const navigate = useNavigate();

    


    return (
        <div className="about-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="about-hero-section"
                style={{ backgroundImage: `url(${aboutHeroBg})` }}
            >
                <Navbar />
            </section>

            {/* 2. Core Narrative & Brand Pillars Section */}
            <section className="about-details-section">
                <div className="container">
                    <div className="row align-items-center g-5">

                        {/* Left Column: Contextual Narrative */}
                        <div className="col-lg-6">
                            <p className="info-small-text">DISCOVER CRESTEST</p>

                            <h2 className="about-section-heading">
                                Empowering Every Student to Learn & Succeed
                            </h2>

                            <div className="zigzag-divider mb-4"></div>

                            <p className="about-body-text">
                                Crestest is an AI-powered learning platform that helps students learn smarter through personalized practice, performance insights, and engaging assessments for school and competitive exams.
                            </p>

                            <p className="about-body-text highlighted-paragraph">
                                Explore board exam preparation, competitive test series, the free "Try Before You Buy" portal, Scholars' Forum, and the nationwide Kirnavali challenge—all designed to build confidence and academic success.
                            </p>

                            {/* Metric Pillars Grid */}
                            <div className="row g-3 mt-4">
                                <div className="col-sm-4">
                                    <div className="metric-box box-blue">
                                        <h3 style={{ color: "#fff" }}>AI</h3>
                                        <p style={{ color: "#fff", fontSize: "11px" }}>
                                            Personalized Learning
                                        </p>
                                    </div>
                                </div>

                                <div className="col-sm-4">
                                    <div className="metric-box box-yellow">
                                        <h3 style={{ color: "#fff" }}>24/7</h3>
                                        <p style={{ color: "#fff" }}>
                                            Smart Practice
                                        </p>
                                    </div>
                                </div>

                                <div className="col-sm-4">
                                    <div className="metric-box box-teal">
                                        <h3 style={{ color: "#fff" }}>FREE</h3>
                                        <p style={{ color: "#fff", fontSize: "11px" }}>
                                            Try Before You Buy
                                        </p>
                                    </div>
                                </div>
                            </div>


                        </div>

                        {/* Right Column: Clean, Unboxed Raw Image Layout */}
                        <div className="col-lg-6 text-center">
                            <img
                                src={aboutDetailsImg}
                                alt="Enterprise Architecture"
                                className="img-fluid"
                                style={{
                                    border: "none",
                                    boxShadow: "none",
                                    outline: "none",
                                    borderRadius: 0,
                                    background: "transparent",
                                    display: "block",
                                    margin: "0 auto"
                                }}
                            />
                        </div>

                    </div>
                </div>
            </section>

           

            {/* 4. Glassmorphic Grid Services / Capabilities Section */}
            <section className="about-grid-bg-section" style={{ backgroundImage: `url(${featureSectionBg2})` }}>
                <div className="container">

                    {/* Centralized Section Header */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">
                            <span className="grid-section-mini-tag">WHY CRESTEST</span>
                            <h2 className="grid-section-heading">Our Mission, Approach & Commitment</h2>
                            <div className="zigzag-border mx-auto mt-3"></div>
                        </div>
                    </div>

                    {/* 2 Cards Per Row */}
                    <div className="row g-4 justify-content-center">

                        {/* Mission */}
                        <div className="col-lg-6">
                            <div className="glass-grid-box">
                                <div className="grid-box-inner">
                                    <div className="grid-square-icon-wrapper accent-blue">
                                        <img
                                            src={Why1}
                                            alt="Mission"
                                            className="grid-panel-image"
                                        />
                                    </div>

                                    <div className="grid-box-text-block">
                                        <h4>Mission</h4>
                                        <p>
                                            Crestest aims to achieve scholastic and competitive excellence by
                                            nurturing self-aware, responsible, and responsive learners. We
                                            inspire curiosity, fearless questioning, and motivated learning,
                                            enabling students to build their own pathways toward academic
                                            success through critical thinking and exploration.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Approach */}
                        <div className="col-lg-6">
                            <div className="glass-grid-box">
                                <div className="grid-box-inner">
                                    <div className="grid-square-icon-wrapper accent-yellow">
                                        <img
                                            src={Why2}
                                            alt="Approach"
                                            className="grid-panel-image"
                                        />
                                    </div>

                                    <div className="grid-box-text-block">
                                        <h4>Approach</h4>
                                        <p>
                                            We follow a learner-centric approach that addresses every student's
                                            individual needs through practical guidance, empathetic mentoring,
                                            and a growth mindset. Our integrated learning model strengthens
                                            conceptual understanding while preparing students for both board
                                            and competitive examinations.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Quality */}
                        <div className="col-lg-6">
                            <div className="glass-grid-box">
                                <div className="grid-box-inner">
                                    <div className="grid-square-icon-wrapper accent-teal">
                                        <img
                                            src={Why3}
                                            alt="Quality"
                                            className="grid-panel-image"
                                        />
                                    </div>

                                    <div className="grid-box-text-block">
                                        <h4>Quality</h4>
                                        <p>
                                            Through concept maps, concise notes, expert webinars, intensive
                                            practice sessions, and an interactive doubt-solving platform, we
                                            build strong academic foundations. Our expertly curated content is
                                            presented using engaging audio-visual experiences for better
                                            understanding and retention.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Our Commitment */}
                        <div className="col-lg-6">
                            <div className="glass-grid-box">
                                <div className="grid-box-inner">
                                    <div className="grid-square-icon-wrapper accent-teal">
                                        <img
                                            src={Why4}
                                            alt="Our Commitment"
                                            className="grid-panel-image"
                                        />
                                    </div>

                                    <div className="grid-box-text-block">
                                        <h4>Our Commitment</h4>
                                        <p>
                                            We are committed to providing accessible, reliable, and
                                            comprehensive academic support throughout every student's learning
                                            journey. Our transparent evaluation and progress monitoring tools
                                            empower students, parents, and educators to track growth and
                                            achieve meaningful success together.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Download App Section */}
            <DownloadApp />

            {/* --- NEW SECTION INSERTION --- */}
            <section className="about-feature-grid-offset-section" style={{ backgroundImage: `url(${featureSectionBg})` }}>
                <div className="container py-5">
                    <div className="row align-items-center g-5">
                        {/* Left Column Content */}
                        {/* Left Column Content */}
                        <div className="col-lg-5">
                            <p className="info-small-text">OUR TEAM</p>

                            <h2 className="about-section-heading">
                                Passionate Minds Driving Student Success
                            </h2>

                            <div className="zigzag-divider mb-4"></div>

                            <p className="about-body-text">
                                Crestest is powered by a dedicated team of educators, researchers, designers, and technology professionals committed to transforming the learning experience. Together, they create engaging, high-quality educational resources that inspire curiosity and academic excellence.
                            </p>

                            <p className="about-body-text mt-3">
                                While our content experts build concept-driven learning materials, our creative designers make them visually engaging, and our IT team ensures a seamless, reliable, and accessible digital learning platform for every student.
                            </p>
                        </div>

                        {/* Right Column: 4 Staggered Boxes Grid */}
                        <div className="col-lg-7">
                            <div className="row g-4">
                                {/* Left Column */}
                                <div className="col-sm-6 d-flex flex-column gap-4 staggered-left-col">
                                    <div
                                        className="staggered-box box-theme-1"
                                        onClick={() => navigate("/founders")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div className="staggered-icon-circle">
                                            <img src={Team1} alt="Feature 1" className="staggered-img" />
                                        </div>
                                        <h4 className="staggered-box-heading">Founders</h4>
                                    </div>

                                    <div
                                        className="staggered-box box-theme-2"
                                        onClick={() => navigate("/founders")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div className="staggered-icon-circle">
                                            <img src={Team2} alt="Feature 2" className="staggered-img" />
                                        </div>
                                        <h4 className="staggered-box-heading">Advisors</h4>
                                    </div>
                                </div>

                                {/* Right Column */}
                                <div className="col-sm-6 d-flex flex-column gap-4 pt-sm-5 staggered-right-col">
                                    <div
                                        className="staggered-box box-theme-3"
                                        onClick={() => navigate("/founders")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div className="staggered-icon-circle">
                                            <img src={Team3} alt="Feature 3" className="staggered-img" />
                                        </div>
                                        <h4 className="staggered-box-heading">Patrons</h4>
                                    </div>

                                    <div
                                        className="staggered-box box-theme-4"
                                        onClick={() => navigate("/founders")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div className="staggered-icon-circle">
                                            <img src={Team4} alt="Feature 4" className="staggered-img" />
                                        </div>
                                        <h4 className="staggered-box-heading">Board Members</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 3. Reusable Global Bottom Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default About;